<template>
    <!-- 报警记录 - 监测点列 -->
    <div>
        <i v-icon="['carrierTypeConvert', row.type + 1]"></i>
        <span class="ellipsis" :title="`${row.fullStructurePath}/${row.carrierName}`">{{ row[index] }}</span>
    </div>
</template>

<script>
import { icon } from '@/utils/convert';
import { carrierTypeConvert } from "@/utils/convert";

export default {
    props: ['row', 'index'],
    data: () => {
        return {
            abnormal: icon.abnormal
        };
    },
    computed: {
        carrierTypeConvert: () => carrierTypeConvert
    }
};
</script>

<style scoped lang="scss"></style>
